import { Optional, Pipe, PipeTransform } from '@angular/core';
import { MeasurementSystem } from '../../auth/models/mmu-user-preferences';
import { MmuUserService } from '../../auth/user-service/mmu-user.service';
import { MmuFormatNumberPipe } from '../format-number/format-number.pipe';
import { LengthConversion, MmuLengthPipe } from './length.pipe';


export enum LengthUnit {
  MM = 'mm',
  INCH = 'in'
}

@Pipe({
  name: 'formatLength'
})
export class MmuFormatLengthPipe implements PipeTransform {
  private lengthPipe: MmuLengthPipe;
  private formatNumberPipe: MmuFormatNumberPipe;
  private readonly lengthUnit: LengthUnit;

  constructor(@Optional() private mmuUserService: MmuUserService) {
    if (this.mmuUserService) {
      this.lengthUnit = this.mmuUserService.user?.prefs?.measurementSystem === MeasurementSystem.METRIC ? LengthUnit.MM : LengthUnit.INCH;
    } else {
      this.lengthUnit = LengthUnit.MM;
    }
    this.lengthPipe = new MmuLengthPipe();
    this.formatNumberPipe = new MmuFormatNumberPipe(this.mmuUserService);
  }

  transform(length: number, digitsInfo?: string): string {
    const convertValue: number = this.lengthUnit == LengthUnit.INCH ? this.lengthPipe.transform(length, LengthConversion.MM_INCH) : length;
    const valueString: string = this.formatNumberPipe.transform(convertValue, digitsInfo);
    return valueString + ' ' + this.lengthUnit;
  }
}
